// src/utils/orderUtils.js
import { apiFetch } from './apiClient';
import { BASE_URL } from './config';
import { getSessionId } from '../components/topbar/SessionTracker';

/**
 * Checks for and handles abandoned orders.
 * @param {object} context - An object containing user, updateUser, refreshUser, fetchCart, and addNotification.
 */
export const handleAbandonedOrderCheck = async (context) => {
  const { user, updateUser, refreshUser, fetchCart, addNotification, t } = context;

  if (!user.isLoggedIn) return;

  // If the user is on the payment selection page, do not run the abandoned order check.
  if (window.location.pathname.includes('/select-payment')) {
    console.log('[orderUtils] On payment selection page, skipping abandoned order check.');
    return;
  }

  try {
    const response = await apiFetch(`${BASE_URL}/api/orders/check-abandoned`, {}, user.token);
    if (!response.ok) {
      console.error(`[orderUtils] Failed to check for abandoned orders, status: ${response.status}`);
      return;
    }

    const { abandonedOrder } = await response.json();

    if (abandonedOrder) {
      const currentSessionId = getSessionId();
      if (abandonedOrder.initiatingSessionId === currentSessionId) {
        // Same tab: auto-cancel the order.
        console.log(`[orderUtils] Found abandoned order ${abandonedOrder._id} from the same session. Auto-cancelling.`);
        const cancelResponse = await apiFetch(
          `${BASE_URL}/api/payments/cancel`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ orderId: abandonedOrder._id }),
          },
          user.token
        );

        const cancelResult = await cancelResponse.json();
        if (cancelResponse.ok) {
          addNotification(t('orderUtils.incompleteOrderCancelled'), 'info');
          if (cancelResult.user) {
            updateUser(cancelResult.user);
          } else {
            refreshUser(); // Fallback
          }
          fetchCart();
        } else {
          addNotification(cancelResult.message || t('orderUtils.cancelFailed'), 'error');
        }
      } else {
        // Different tab: just notify the user and refresh data.
        addNotification(t('orderUtils.incompletePaymentOtherTab'), 'warning', 7000);
        refreshUser();
        fetchCart();
      }
    }
  } catch (err) {
    console.error('[orderUtils] Error during abandoned order check:', err);
  }
};
